import { records } from './mocks';
import { TaxType } from './reference-book-taxpayer-codes.types';

const BASE_URL = '';

export const getData = async (): Promise<TaxType[]> => {
    return records;
};
